import VueI18n from 'vue-i18n';
import { Route } from 'vue-router';
import { Routes } from '@front-app/constants/routes';
import { getAsArray } from '@front-app/router/util/getFromRequest';
import { PhoenixRouteConfig } from '@front-app/router/Model';
import { DeeplinkKey } from '@front-app/views/home/group/discussion/GroupDiscussionEnum';

export const content: PhoenixRouteConfig[] = [
	{
		meta: {
			title(i18n: VueI18n): string {
				return i18n.t('group.tabs.content') as string;
			},
			trappRoute(to: Route): string {
				return `/fgf.shtml?hcgd=${to.params.groupId}`;
			},
		},
		path: 'content',
		name: Routes.GROUP_CONTENT,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			return {
				search: route.query.search,
				categories: getAsArray(route.query.categories),
				types: getAsArray(route.query.types),
				sort: route.query.sort,
				showContent: route.query.showContent,
			};
		},
		component: () => import(/* webpackChunkName: "group_content" */ '@front-app/views/home/group/GroupContent.vue'),
	},
	{
		meta: {
			title(i18n: VueI18n): string {
				return i18n.t('page.title.discussions') as string;
			},
			trappRoute(to: Route): string {
				return `/fgmbgi.shtml?md=${to.params.discussionId}&hcgd=${to.params.groupId}`;
			},
		},
		path: 'discussions/:discussionId',
		name: Routes.GROUP_DISCUSSION,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			return {
				discussionId: route.params.discussionId,
				deeplinkNoteId: route.query[DeeplinkKey.NOTE_ID],
				deeplinkNoteMessageId: route.query[DeeplinkKey.NOTE_MESSAGE_ID],
				showContent: route.query.showContent,
			};
		},
		component: () => import(/* webpackChunkName: "group_discussion" */ '@front-app/views/home/group/GroupDiscussion.vue'),
	},
];
